module.exports = __webpack_public_path__ + "static/media/OBS_ISO.c1b66fb3.png";